module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-f0bcf9a59d435bc70f93aa7a7cf3efe9.png";